module.exports = __webpack_public_path__ + "static/img/photo8.d65d50de.jpg";